<template>
  <div>
    <div @click="seeMoreHandle">
      <slot> </slot>
    </div>
    <Teleport to="body">
      <transition>
        <div class="video_mask" v-if="openMask" @click.self="closeMask">
          <div class="close_btn">
            <span
              class="btn btn1"
              @click="closeMask"
              bg-url="@/auto/assets/image/1/default.png"
              v-bg
            ></span>
            <span
              class="btn btn2"
              @click="closeMask"
              bg-url="@/auto/assets/image/1/hover.png"
              v-bg
            ></span>
          </div>

          <m-video
            class="mask_video"
            disablepictureinpicture
            :poster="posterSrc"
            :src="videoSrc"
            controlslist="nodownload"
            autoplay
            controls
            ref="mask_video"
          ></m-video>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import Teleport from 'vue2-teleport'
export default {
  props: {
    videoSrc: String,
    posterSrc: String,
  },
  components: {
    Teleport,
  },
  data() {
    return {
      preload_: true,
      openMask: false,
    }
  },
  mounted() {},
  watch: {
    openMask(open) {
      if (!open) return
      this.seeMoreHandle()
    },
  },
  methods: {
    seeMoreHandle() {
      this.openMask = true
      document.body.style = 'overflow: hidden;'
    },
    closeMask() {
      const video = this.$refs.mask_video
      video.pause()

      this.openMask = false
      document.body.style = 'overflow: inhert;'
    },
  },
}
</script>

<style lang="less" scoped>
.video_mask {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 100;
  background-color: #000;

  .close_btn {
    position: absolute;
    top: 10%;
    right: 10%;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &:hover {
      .btn1 {
        display: none;
      }

      .btn2 {
        display: inline-block;
      }
    }

    .btn {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      background-size: 100%;
    }

    .btn2 {
      display: none;
    }
  }
}

.mask_video {
  position: absolute;
  max-width: 70%;
  max-height: 70%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
